<template>
  <ul
    data-animate="list"
    class="page-designers-list__list"
    v-anim-parallax-element="{
      target: 'picture',
      offset: 10,
    }"
  >
    <li v-for="(designer, index) in formattedDesigners" :key="designer.id">
      <div
        class="page-designers-list__list__item"
        v-anim-scroll-speed="{
          factor: index % 2 !== 0 ? 0.25 : 0,
        }"
      >
        <WidgetContentBlock :content="designer" />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PagesFinishingsList',
}
</script>

<script setup>
const props = defineProps({
  designers: Array,
})

const formattedDesigners = computed(() => {
  return props.designers.map((designer, index, array) => {
    return {
      title: designer.title,
      cover: designer.designerImage?.[0],
      route: {
        name: 'designers-slug',
        params: { slug: designer.slug },
      },
    }
  })
})
</script>

<style lang="scss">
@import './style.scss';
</style>
